<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <div class="toast-overlay">
    <toast-notification
      v-for="(toast, index) of toasts"
      :id="toast.id"
      :key="index"
      :title="
        toast.productTitle
          ? $string('cart.freebies.autoAddToast', {
              replace: { productTitle: toast.productTitle },
            })
          : toast.title
      "
      :cta-text="toast.ctaText"
      :type="toast.type"
      :cta-callback="toast.callback"
    />
  </div>
</template>

<script>
/**
 * Vue: toast-overlay (toast-overlay)
 * -----------------------------------------------------------------------------
 * Overlay for displaying toast notifications.
 * - Component settings: section / dynamic / global
 */
import { mapState } from 'pinia';
import useToastNotificationsStore from '~stores/toast-notifications';

import ToastNotification from '~global/toast-overlay/toast-notification.vue';

export default {
  name: 'ToastOverlay',

  components: {
    ToastNotification,
  },

  data() {
    return {
      cnvsGlobal: 'true',
    };
  },

  computed: {
    ...mapState(useToastNotificationsStore, ['toasts']),
  },
};
</script>
